
@if (updateCheckService.updateAvailable$ | async) {
  <update-modal (countdownFinished)="updateCheckService.applyUpdate()"
    (deferred)="updateCheckService.deferUpdate()" [countdownSeconds]="10"></update-modal>
}


<!-- router-outlet'i her zaman görünür hale getirin -->
@if (backgroundService.backgroundVisible$ | async) {
  <app-background class="absolute h-screen bg-header left-0 right-0 mx-auto overflow-hidden"></app-background>
}

<!-- div Class for Toaster middle in the screen -->
<router-outlet [class.hidden]="updateCheckService.updateAvailable$ | async"></router-outlet>

@if (screenSaver.isActive() | async) {
  <app-screensaver></app-screensaver>
}

<div
  class="absolute right-0 left-auto max-h-screen overflow-y-auto overflow-x-hidden flex flex-col mt-20 mr-2 transition-all duration-300"
  style="direction: rtl; box-sizing: border-box; padding: 0; z-index:5000;" [class.w-[450px]]="!toastNotify.isMuted"
  (mouseenter)="onToastContainerHover(true)"
  (mouseleave)="onToastContainerHover(false)">

  <div style="direction: ltr;" class="m-0 p-0" [hidden]="toastNotify.isMuted" toastContainer>

  </div>
</div>
